import { defineMessages } from 'react-intl';

export default defineMessages({
    packageLocation: {
        id: 'gateway.package-info.Location',
        defaultMessage: 'Location'
    },
    packageAdd: {
        id: 'gateway.package-info.Add',
        defaultMessage: 'Add'
    },
    packageEdit: {
        id: 'gateway.package-info.Edit',
        defaultMessage: 'Edit'
    },
    packageSave: {
        id: 'gateway.package-info.Save',
        defaultMessage: 'Save'
    },
    packageCancel: {
        id: 'gateway.package-info.Cancel',
        defaultMessage: 'Cancel'
    },
    packageGeneralDetails: {
        id: 'gateway.package-info.General Details',
        defaultMessage: 'General Details'
    },
    occupantDateOfBirth: {
        id: "gateway.package-info.Occupant's DOB",
        defaultMessage: "Occupant's DOB"
    },
    structureType: {
        id: 'gateway.package-info.Structure Type',
        defaultMessage: 'Structure Type'
    },
    personalOccupancy: {
        id: 'gateway.package-info.Occupancy Type',
        defaultMessage: 'Occupancy Type'
    },
    primaryConstructionType: {
        id: 'gateway.package-info.Exterior Wall Finish',
        defaultMessage: 'Exterior Wall Finish'
    },
    secondaryConstructionType: {
        id: 'gateway.package-info.Exterior Wall Frame',
        defaultMessage: 'Exterior Wall Frame'
    },
    numUnits: {
        id: 'gateway.package-info.No. of Units/Apartments Rented To Others',
        defaultMessage: 'No. of Units/Apartments Rented To Others'
    },
    numFamilies: {
        id: 'gateway.package-info.No. of Families',
        defaultMessage: 'No. of Families'
    },
    hasPool: {
        id: 'gateway.package-info.Is there a Swimming Pool?',
        defaultMessage: 'Is there a Swimming Pool?'
    },
    isPoolCompliant: {
        id: 'gateway.package-info.Is the Swimming Pool by-law compliant?',
        defaultMessage: 'Is the Swimming Pool by-law compliant?'
    },
    hasHotTub: {
        id: 'gateway.package-info.Is there a Hot Tub?',
        defaultMessage: 'Is there a Hot Tub?'
    },
    isHottubComplaint: {
        id: 'gateway.package-info.Is the Hot tub by-law compliant?',
        defaultMessage: 'Is the Hot tub by-law compliant?'
    },
    numberOfWeeks: {
        id: 'gateway.package-info.No. of Weeks rented on tenants',
        defaultMessage: 'No. of Weeks rented to others'
    },
    roomerBoardersNumber: {
        id: 'gateway.package-info.No. of Roomers and Boarders?',
        defaultMessage: 'No. of Roomers and Boarders?'
    },
    yearBuilt: {
        id: 'gateway.package-info.Year Built',
        defaultMessage: 'Year Built'
    },
    numStories: {
        id: 'gateway.package-info.No. Of Stories',
        defaultMessage: 'No. Of Stories'
    },
    buildingArea: {
        id: 'gateway.package-info.Building area (square feet)',
        defaultMessage: 'Building area (square feet)'
    },
    isBasementFinished: {
        id: 'gateway.package-info.Is Basement Finished?',
        defaultMessage: 'Is Basement Finished?'
    },
    basementFinishedPercent: {
        id: 'gateway.package-info.Basement Finished (%)',
        defaultMessage: 'Basement Finished (%)'
    },
    isBuildingUnderRenovation: {
        id: 'gateway.package-info.Is the building under renovation?',
        defaultMessage: 'Is the building under renovation?'
    },
    fireProtectionGrade: {
        id: 'gateway.package-info.Fire Protection',
        defaultMessage: 'Fire Protection'
    },
    isRoadAccessiblee: {
        id: 'gateway.package-info.Road Accessible Year Round?',
        defaultMessage: 'Road Accessible Year Round?'
    },
    buildingDetails: {
        id: 'gateway.package-info.Other Building Details',
        defaultMessage: 'Other Building Details'
    },
    heating: {
        id: 'gateway.package-info.Heating',
        defaultMessage: 'Heating'
    },
    primaryHeating: {
        id: 'gateway.package-info.Primary Heating Type',
        defaultMessage: 'Primary Heating Type'
    },
    primaryFuel: {
        id: 'gateway.package-info.Primary Fuel Type',
        defaultMessage: 'Primary Fuel Type'
    },
    secondaryHeating: {
        id: 'gateway.package-info.Secondary Heating Type',
        defaultMessage: 'Secondary Heating Type'
    },
    secondaryFuel: {
        id: 'gateway.package-info.Secondary Fuel Type',
        defaultMessage: 'Secondary Fuel Type'
    },
    hasheatingUpdated: {
        id: 'gateway.package-info.Has Heating been Updated?',
        defaultMessage: 'Has Heating been Updated?'
    },
    heatingUpdateType: {
        id: 'gateway.package-info.heating.Update Type',
        defaultMessage: 'Update Type'
    },
    heatingUpdateYear: {
        id: 'gateway.package-info.heating.Year of Update',
        defaultMessage: 'Year of Update'
    },
    roofDetails: {
        id: 'gateway.package-info.Roof',
        defaultMessage: 'Roof'
    },
    roofMaterial: {
        id: 'gateway.package-info.Roof Material',
        defaultMessage: 'Roof Material'
    },
    hasRoofUpdated: {
        id: 'gateway.package-info.Has Roof been Updated?',
        defaultMessage: 'Has Roof been Updated?'
    },
    roofUpdateType: {
        id: 'gateway.package-info.roof.Update Type',
        defaultMessage: 'Update Type'
    },
    roofUpdateYear: {
        id: 'gateway.package-info.roof.Year of Update',
        defaultMessage: 'Year of Update'
    },
    protectionDetails: {
        id: 'gateway.package-info.Protection',
        defaultMessage: 'Protection'
    },
    burglarAlarmSystem: {
        id: 'gateway.package-info.Burglar Alarm System',
        defaultMessage: 'Burglar Alarm System'
    },
    sprinklerSystem: {
        id: 'gateway.package-info.Sprinkler System',
        defaultMessage: 'Sprinkler System'
    },
    fireSmokeSystem: {
        id: 'gateway.package-info.Fire/Smoke Alarm',
        defaultMessage: 'Fire/Smoke Alarm'
    },
    evaluationDetails: {
        id: 'gateway.package-info.',
        defaultMessage: 'Evaluation'
    },
    appraiserName: {
        id: 'gateway.package-info.Evaluator',
        defaultMessage: 'Evaluator'
    },
    appraisedCost: {
        id: 'gateway.package-info.Estimated Replacement Cost',
        defaultMessage: 'Estimated Replacement Cost'
    },
    evaluationDate: {
        id: 'gateway.package-info.Evaluation Date',
        defaultMessage: 'Evaluation Date'
    },
    electricDetails: {
        id: 'gateway.package-info.Electrical',
        defaultMessage: 'Electrical'
    },
    elecServAmp: {
        id: 'gateway.package-info.Electrical Service Amp',
        defaultMessage: 'Electrical Service Amp'
    },
    elecPanelType: {
        id: 'gateway.package-info.Panel Type',
        defaultMessage: 'Panel Type'
    },
    hasElecUpdated: {
        id: 'gateway.package-info.Has Electrical been Updated?',
        defaultMessage: 'Has Electrical been Updated?'
    },
    elecUpdateType: {
        id: 'gateway.package-info.Update Type',
        defaultMessage: 'Update Type'
    },
    elecYearUpdate: {
        id: 'gateway.package-info.Year of Update',
        defaultMessage: 'Year of Update'
    },
    wiringType: {
        id: 'gateway.package-info.Type of Wiring',
        defaultMessage: 'Type of Wiring'
    },
    hasOtherWiring: {
        id: 'gateway.package-info.Other Wiring',
        defaultMessage: 'Other Wiring'
    },
    otherWiringType: {
        id: 'gateway.package-info.Type of Other Wiring',
        defaultMessage: 'Type of Other Wiring'
    },
    plumbing: {
        id: 'gateway.package-info.Plumbing',
        defaultMessage: 'Plumbing'
    },
    plumbingType: {
        id: 'gateway.package-info.Plumbing Supply Type',
        defaultMessage: 'Plumbing Supply Type'
    },
    hasAddPlumbSupply: {
        id: 'gateway.package-info.Add. Plumbing Supply',
        defaultMessage: 'Add. Plumbing Supply'
    },
    addPlumbingType: {
        id: 'gateway.package-info.Add. Plumbing Supply Type',
        defaultMessage: 'Add. Plumbing Supply Type'
    },
    hasPlumbingUpdated: {
        id: 'gateway.package-info.Has Plumbing been updated?',
        defaultMessage: 'Has Plumbing been updated?'
    },
    isSumpPump: {
        id: 'gateway.package-info.Is there a sump pump?',
        defaultMessage: 'Is there a sump pump?'
    },
    plumbingUpdateType: {
        id: 'gateway.package-info.Update Type',
        defaultMessage: 'Update Type'
    },
    plumbingUpdateYear: {
        id: 'gateway.package-info.Year of Update',
        defaultMessage: 'Year of Update'
    },
    sumpPumpAmount: {
        id: 'gateway.package-info.Number of Sump pumps?',
        defaultMessage: 'Number of Sump pumps?'
    },
    backupPower: {
        id: 'gateway.package-info.Back-up Power source',
        defaultMessage: 'Back-up Power source - Hardwire/Battery Backup/Water Powered/Generator'
    },
    drainType: {
        id: 'gateway.package-info.Drain Type',
        defaultMessage: 'Drain Type'
    },
    noOilTanksInDwelling: {
        id: 'gateway.package-info.No. of Oil Tanks',
        defaultMessage: 'No. of Oil Tanks'
    },
    isInspectionRptRecieved: {
        id: 'gateway.package-info.OBT Inspection report received?',
        defaultMessage: 'OBT Inspection report received?'
    },
    oilTankYear: {
        id: 'gateway.package-info.Oil Tank Year',
        defaultMessage: 'Oil Tank Year'
    },
    tankLocation: {
        id: 'gateway.package-info.Tank Location',
        defaultMessage: 'Tank Location'
    },
    oilFilterLocation: {
        id: 'gateway.package-info.Oil Filter Location',
        defaultMessage: 'Oil Filter Location'
    },
    oilTankOutletLocation: {
        id: 'gateway.package-info.Outlet Location',
        defaultMessage: 'Outlet Location'
    },
    tankType: {
        id: 'gateway.package-info.Tank Type',
        defaultMessage: 'Tank Type'
    },
    tankGauge: {
        id: 'gateway.package-info.Tank Gauge',
        defaultMessage: 'Tank Gauge'
    },
    isCSAULCApproved: {
        id: 'gateway.package-info.Is CSA/ULC Approved?',
        defaultMessage: 'Is CSA/ULC Approved?'
    },
    isProInstalled: {
        id: 'gateway.package-info.Professionally Installed?',
        defaultMessage: 'Professionally Installed?'
    },
    isProCleaned: {
        id: 'gateway.package-info.Professionally Cleaned?',
        defaultMessage: 'Professionally Cleaned?'
    },
    hasWoodstovesinDwelling: {
        id: 'gateway.package-info.Wood Stoves located in Dwelling?',
        defaultMessage: 'Wood Stoves located in Dwelling?'
    },
    noOfWoodStovesInDwelling: {
        id: 'gateway.package-info.No of Wood Stoves located in Dwelling',
        defaultMessage: 'No. of Wood Stoves located in Dwelling'
    },
    hasWoodstovesinOutbuilding: {
        id: 'gateway.package-info.Wood Stoves located in Outbuilding?',
        defaultMessage: 'Wood Stoves located in Outbuilding?'
    },
    noOfWoodStovesInOutbuilding: {
        id: 'gateway.package-info.No of Wood Stoves located in Outbuilding',
        defaultMessage: 'No. of Wood Stoves located in Outbuilding'
    },
    moreDetails: {
        id: 'gateway.package-info.More Details',
        defaultMessage: 'More Details'
    },
    packageDetailsHide: {
        id: 'gateway.package-info.Hide',
        defaultMessage: 'Hide'
    },
    packageDetailsShow: {
        id: 'gateway.package-info.Show',
        defaultMessage: 'Show'
    },
    additionalInsuredInterestHeading: {
        id: 'gateway.policy-info.Additional Insureds & Additional Interests',
        defaultMessage: 'Additional Insureds & Additional Interests'
    },
    additionalInterestsHeading: {
        id: 'gateway.policy-info.Additional Interests',
        defaultMessage: 'Additional Interests'
    },
    roofType: {
        id: 'gateway.package-info.Roof Type',
        defaultMessage: 'Roof Type'
    },
    hasAnyPond: {
        id: 'gateway.package-info.Do you have any ponds?',
        defaultMessage: 'Do you have any ponds?'
    },
    numberOfPonds: {
        id: 'gateway.package-info.No. of Ponds',
        defaultMessage: 'No. of Ponds'
    },
    isTied: {
        id: "gateway.package-info.isTied?",
        defaultMessage: 'Tied?'
    },
    isSkirted: {
        id: 'gateway.package-info.isSkirted?',
        defaultMessage: 'Skirted?'
    },
    anytypeOfHomeBusiness: {
        id: 'gateway.package-info.Any type Of HomeBusiness?',
        defaultMessage: 'Any type Of HomeBusiness?'
    },
    typeOfBusinss: {
        id: 'gateway.package-info.Type of Business',
        defaultMessage: 'Type of Business'
    },
    superiorShuttle: {
        id: 'gateway.package-info.Superior Shuttle',
        defaultMessage: 'Superior Shuttle'
    },
    distanceToFirehall_EY: {
        id: 'gateway.package-info.Distance to firehall',
        defaultMessage: 'Distance to firehall'
    },
    fullTimeFireDepartment: {
        id: 'gateway.package-info.Full Time Fire Department',
        defaultMessage: 'Full Time Fire Department'
    },
    packageTenantDetails: {
        id: 'gateway.package-info.Tenant Details',
        defaultMessage: 'Tenant Details'
    },
    packageTrailerDetails: {
        id: 'gateway.package-info.Trailer Details',
        defaultMessage: 'Trailer Details'
    },
    packageYear: {
        id: 'gateway.package-info.Year',
        defaultMessage: 'Year'
    },
    packageMake: {
        id: 'gateway.package-info.Make',
        defaultMessage: 'Make'
    },
    packageModel: {
        id: 'gateway.package-info.Model',
        defaultMessage: 'Model'
    },
    packageVin: {
        id: 'gateway.package-info.Vin',
        defaultMessage: 'Vin / Serial #'
    },
    packageLength: {
        id: 'gateway.package-info.Length',
        defaultMessage: 'Length (ft)'
    },
    packageValue: {
        id: 'gateway.package-info.Value',
        defaultMessage: 'Value'
    },
    packageParked: {
        id: 'gateway.package-info.Parked',
        defaultMessage: 'Is the Trailer permanently parked?'
    },
    foundationType: {
        id: 'gateway.package-info.Foundation Type',
        defaultMessage: 'Foundation Type'
    },
    numKitchens: {
        id: 'gateway.package-info.No. of Kitchens',
        defaultMessage: 'No. of Kitchens'
    }
});
